<template>
  <a-row :gutter="[16, 16]" class="p-4">
    <a-col span="24">
      <RichFilters @change="handleFiltersChange" />
    </a-col>

    <a-col span="24">
      <ValueStoryROISection :filters="filterValues" />
    </a-col>
  </a-row>
</template>

<script>
import RichFilters from 'src/components/shared/Components/RichFilters.vue';
import ValueStoryROISection from './ValueStoryROISection.vue';

export default {
  name: 'ValueStoryPage',
  components: { RichFilters, ValueStoryROISection },
  data() {
    return {
      filterValues: null,
    };
  },
  methods: {
    handleFiltersChange(filters) {
      this.filterValues = filters;
    },
  },
};
</script>
